import { render } from "./EventsHero.vue?vue&type=template&id=785a7ac0&scoped=true"
import script from "./EventsHero.vue?vue&type=script&lang=js"
export * from "./EventsHero.vue?vue&type=script&lang=js"

import "./EventsHero.vue?vue&type=style&index=0&id=785a7ac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785a7ac0"]])

export default __exports__